import React from 'react';

export default function SEO({ title, description, image, slugPath, noindex = false }) {
  const siteUrl = window.location.origin;
  const canonicalUrl = slugPath ? `${siteUrl}${slugPath}` : window.location.href;
  const finalTitle = title ? `${title} | Amalgamate` : 'Amalgamate - Your Unified Platform';
  const finalDescription = description?.substring(0, 155) || 'Amalgamate - Facilitate marketplace offerings, educate through certifications, and earn rewards.';
  
  // Format OG Image to ensure it is an absolute URL
  const finalImage = image 
    ? (image.startsWith('http') ? image : `${siteUrl}${image.startsWith('/') ? '' : '/'}${image}`) 
    : `${siteUrl}/amalgamateA.svg`;

  return (
    <>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Search Engine Directives */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* OpenGraph Tags for Social Sharing */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
    </>
  );
}
